/**
 * @author  Kheops Technologies SA <devops@kheops.ch>
 * @copyright Kheops Technologies SA
 */
import ChainingManagementServiceList from './ChainingManagementServiceList.vue'

export * from './ChainingManagementServiceList.vue'
export default ChainingManagementServiceList
